import React from 'react';
export function Reframe() {
  return <section className="bg-brand-black px-4 py-20 sm:px-6 lg:px-8 lg:py-24 border-t border-white/10" data-id="element-190">
      <div className="mx-auto max-w-3xl" data-id="element-191">
        <div className="mb-12 h-1 w-24 bg-brand-green" data-id="element-192"></div>

        <h2 className="mb-10 text-3xl font-bold text-white sm:text-4xl" data-id="element-193">
          La verdad que nadie te dice sobre vender por WhatsApp:
        </h2>

        <blockquote className="mb-12 border-l-4 border-brand-green bg-white/5 p-6 sm:p-8 rounded-r-xl" data-id="element-194">
          <p className="text-xl font-medium italic leading-relaxed text-gray-200 sm:text-2xl" data-id="element-195">
            "WhatsApp no es un canal de ventas. Es un canal de conversaciones. Y
            las ventas son el resultado natural de saber liderar esas
            conversaciones."
          </p>
        </blockquote>

        <div className="space-y-8 text-lg text-gray-300 sm:text-xl" data-id="element-196">
          <p data-id="element-197">
            <strong className="text-white" data-id="element-198">
              La mayoría de vendedores cometen el mismo error:
            </strong>
            <br data-id="element-199" />
            Tratan WhatsApp como si fuera un{' '}
            <span className="text-brand-green font-bold" data-id="element-200">
              mostrador de tienda
            </span>
            .
          </p>

          <p className="pl-4 border-l-2 border-gray-700" data-id="element-201">
            Esperan. Responden. Despachan.
          </p>

          <p data-id="element-202">
            Pero los vendedores que cierran consistentemente hacen algo
            diferente:
          </p>

          <p className="pl-4 border-l-2 border-brand-green text-white font-bold" data-id="element-203">
            Diagnostican. Guían. Cierran.
          </p>

          <div className="mt-12 rounded-xl bg-brand-green/10 p-8 border border-brand-green/20 text-center" data-id="element-204">
            <p className="mb-2 text-white" data-id="element-205">
              La diferencia entre ambos no es el producto, ni el precio, ni
              siquiera la cantidad de contactos.
            </p>
            <p className="text-3xl font-black text-brand-green uppercase tracking-wide" data-id="element-206">
              Es el sistema.
            </p>
          </div>
        </div>
      </div>
    </section>;
}